import styled from 'styled-components';
import { rem } from 'polished';

import mediaqueries from '../../../../config/themes/variables/mediaqueries';

const StyledTitleDepartment = styled.h2`
  font-size: ${rem('20px')};
  font-family: ${props => props.theme.fonts.bold};
  text-transform: uppercase;
  margin-top: ${rem('30px')};
  padding-left: ${rem('16px')};
  max-width: ${rem('1232px')};

  ${mediaqueries.greaterThan('tablet')`
    padding-left: ${rem('24px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('28px')};
    margin: ${rem('30px')} auto ${rem('20px')} auto;
    padding-left: 0;
  `};
`;

export { StyledTitleDepartment };
